export default __webpack_public_path__ + "static/media/C0053-0.4f0926ce.jpg";